<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask
            id="mask0_262_13128"
            style="mask-type: alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="20"
            height="20"
        >
            <rect width="20" height="20" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_262_13128)">
            <path
                d="M5 15L3.27333 16.7267C3.03556 16.9644 2.76389 17.018 2.45833 16.8873C2.15278 16.7567 2 16.5235 2 16.1875V3.5C2 3.09722 2.14931 2.74653 2.44792 2.44792C2.74653 2.14931 3.09722 2 3.5 2H16.5C16.9125 2 17.2656 2.14931 17.5594 2.44792C17.8531 2.74653 18 3.09722 18 3.5V7.75C18 7.9625 17.9285 8.14063 17.7856 8.28438C17.6427 8.42813 17.4656 8.5 17.2544 8.5C17.0431 8.5 16.8646 8.42813 16.7188 8.28438C16.5729 8.14063 16.5 7.9625 16.5 7.75V3.5H3.5V14.375L4.375 13.5H11.75C11.9625 13.5 12.1406 13.5715 12.2844 13.7144C12.4281 13.8573 12.5 14.0344 12.5 14.2456C12.5 14.4569 12.4281 14.6354 12.2844 14.7813C12.1406 14.9271 11.9625 15 11.75 15H5ZM15.625 15H14.75C14.5375 15 14.3594 14.9281 14.2156 14.7844C14.0719 14.6406 14 14.4625 14 14.25V10.75C14 10.5375 14.0719 10.3594 14.2156 10.2156C14.3594 10.0719 14.5375 10 14.75 10H17.1875C17.3819 10 17.5347 10.0799 17.6458 10.2396C17.7569 10.3993 17.7778 10.5764 17.7083 10.7708L16.75 13.25H17.5833C17.7925 13.25 17.9524 13.3368 18.0631 13.5104C18.1738 13.684 18.1806 13.8681 18.0833 14.0625L15.9792 18.2917C15.9375 18.375 15.8681 18.4072 15.7708 18.3883C15.6736 18.3693 15.625 18.3093 15.625 18.2083V15Z"
                fill="#8796AF"
            />
        </g>
    </svg>
</template>
<script>
export default {
    name: "ReadyContentsSvg",
};
</script>
